import { render, staticRenderFns } from "./TenantMngFormPanel.vue?vue&type=template&id=38ff0e5c&"
import script from "./TenantMngFormPanel.vue?vue&type=script&lang=js&"
export * from "./TenantMngFormPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports